import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/render/project/src/src/components/MdxPageLayout/index.jsx";
import ComparisonResultsPageHero from "../../components/ComparisonResultsPageHero";
import ComparisonResultPageTextWithImageSection from "../../components/ComparisonResultPageTextWithImageSection";
import ComparisonResultHeroUserLocation from "../../components/ComparisonResultHeroUserLocation";
import ComparisonResultGrid from "../../components/ComparisonResultGrid";
import ComparisonResultColumnContent from "../../components/ComparisonResultColumnContent";
import ComparisonResultColumnContentBackgroundContainer from "../../components/ComparisonResultColumnContentBackgroundContainer";
import ComparisonResultGettingStartedBlock from "../../components/ComarisonResultPageGetStartedBlock";
import ComparisonPageRecommendations from "../../components/ComparisonPageRecommendations";
import ComparisonResultPageLearnMoreContainer from "../../components/ComparisonResultPageLearnMoreContainer";
import StudentLoanIllustration from "../../../svg/comparison-illustrations/studentrefinancingloan.svg";
import SplashFinancialLogo from "../../../svg/supplier-color-logos/SplashFinancial.svg";
import EarnestLogo from "../../../svg/supplier-color-logos/Earnest.svg";
export const pageMetaData = {
  pageTitle: "Compare Student Refinancing Loans",
  pageDescription: "Variable APR From 1.89%",
  pageImagePath: "/studentrefinancingloans.jpg",
  showNavbar: false,
  pageMetaTags: []
};
export const resultGridConfig = {
  columnConfiguration: {
    columns: [{
      index: 1,
      rows: [{
        index: 1,
        text: "Loan Amount"
      }, {
        index: 2,
        text: "Suitable For"
      }, {
        index: 3,
        text: "Loan Term"
      }, {
        index: 4,
        text: "Variable APR %"
      }, {
        index: 5,
        text: "Fixed APR %"
      }, {
        index: 6,
        text: "Minimum Credit Score"
      }],
      expansionRows: []
    }, {
      index: 2,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Splash Financial",
          subText: "",
          imageKey: "splash-financial"
        }
      }, {
        index: 2,
        text: "5000 +",
        isPriceCell: true,
        showSavingText: false,
        savingText: "Save From $3,000",
        disableSavingStrikeThrough: true,
        showRating: true,
        rating: 5
      }, {
        index: 3,
        text: "Graduates"
      }, {
        index: 4,
        text: "5 - 20 Years"
      }, {
        index: 5,
        text: "From 1.99%"
      }, {
        index: 6,
        text: "From 2.88%"
      }, {
        index: 7,
        text: "660 +"
      }],
      expansionRows: [],
      claimButtonConfiguration: {
        targetUrl: "https://splash-financial.j48ltb.net/c/1323808/583350/9516",
        openLinkExternally: true,
        text: "Get My Rate",
        title: "Click to sign up to Splash Financial",
        subText: "",
        showIcon: false
      }
    }, {
      index: 3,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Splash Financial Medical",
          subText: "",
          imageKey: "splash-financial"
        }
      }, {
        index: 2,
        text: "5,000 +",
        isPriceCell: true,
        showSavingText: false,
        savingText: "Save From $3,000",
        disableSavingStrikeThrough: true,
        showRating: true,
        rating: 4
      }, {
        index: 3,
        text: "Medical Professionals"
      }, {
        index: 4,
        text: "5 - 20 Years"
      }, {
        index: 5,
        text: "From 2.28%"
      }, {
        index: 6,
        text: "from 3.75%"
      }, {
        index: 7,
        text: "660 +"
      }],
      expansionRows: [],
      claimButtonConfiguration: {
        targetUrl: "https://splash-financial.j48ltb.net/c/1323808/609106/9516?u=https%3A%2F%2Fsplashfinancial.com%2Fmedical-school-student-loan-refinancing",
        openLinkExternally: true,
        text: "Get My Rate",
        subText: "",
        showIcon: false
      }
    }, {
      index: 4,
      isComingSoon: false,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "Earnest",
          subText: "",
          imageKey: "earnest"
        }
      }, {
        index: 2,
        text: "5,000 +",
        isPriceCell: true,
        showSavingText: false,
        savingText: "Save From $3,000",
        disableSavingStrikeThrough: true,
        showRating: true,
        rating: 4
      }, {
        index: 3,
        text: "Debt Consolidation"
      }, {
        index: 4,
        text: "Upto 6 Years"
      }, {
        index: 5,
        text: "From 8.99%"
      }, {
        index: 6,
        text: "From 3.19%"
      }, {
        index: 7,
        text: "650+"
      }],
      expansionRows: [],
      claimButtonConfiguration: {
        targetUrl: "https://www.earnest.com/refinance-student-loans",
        openLinkExternally: true,
        text: "Get My Rate",
        subText: "",
        showIcon: false
      }
    }, {
      index: 5,
      isComingSoon: true,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "",
          subText: "",
          imageKey: ""
        }
      }, {
        index: 2,
        text: "",
        isPriceCell: true,
        showSavingText: false,
        showRating: true,
        rating: 3
      }, {
        index: 3,
        text: ""
      }, {
        index: 4,
        text: ""
      }, {
        index: 5,
        text: ""
      }, {
        index: 6,
        text: ""
      }, {
        index: 7,
        text: ""
      }],
      expansionRows: [],
      claimButtonConfiguration: {
        targetUrl: "https://boro.nrlq2m.net/c/1323808/766823/11081?u=https%3A%2F%2Fwww.getboro.com%2Fcash",
        openLinkExternally: true,
        text: "",
        subText: "",
        showIcon: false
      }
    }, {
      index: 6,
      isComingSoon: true,
      rows: [{
        index: 1,
        isHeadingCell: true,
        displayHeadingCell: true,
        heading: {
          text: "",
          subText: "",
          imageKey: ""
        }
      }, {
        index: 2,
        text: "",
        isPriceCell: true,
        showSavingText: false,
        showRating: false
      }, {
        index: 3,
        text: ""
      }, {
        index: 4,
        text: ""
      }, {
        index: 5,
        text: ""
      }, {
        index: 6,
        text: ""
      }, {
        index: 7,
        text: ""
      }],
      expansionRows: [],
      claimButtonConfiguration: {
        targetUrl: "/",
        openLinkExternally: false,
        text: "",
        subText: "",
        showIcon: false
      }
    }]
  }
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageMetaData,
  resultGridConfig,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComparisonResultsPageHero mdxType="ComparisonResultsPageHero">
      <h1>{`Compare student loan refinancing`}</h1>
      <ComparisonResultPageTextWithImageSection images={[<StudentLoanIllustration imagekey="large-view" className="h-56 ml-auto" mdxType="StudentLoanIllustration" />, <StudentLoanIllustration imagekey="mobile-view" className="h-56 w-full" mdxType="StudentLoanIllustration" />]} mdxType="ComparisonResultPageTextWithImageSection">
        <p>{`The state of student loans in America isnothing less than a crisis. With over 1.5 trillion dollars in student loan debt and at least 42% of millennials worried about paying back student loans they owe, it's
easy to see that college graduates and college students all over the country are struggling with how to pay these loans back. Even more concerning, student loan debt is not only for college graduates -
roughly 9% of people who only have high school degrees also have student debt.`}</p>
        <p>{`Fortunately, there are some great companies that are committed to providing college students and graduates with financial relief. We did the work for you to compare loans for the best student loan refinancing companies.`}</p>
      </ComparisonResultPageTextWithImageSection>
      <ComparisonResultHeroUserLocation productCategory="Student Refinancing Loans" mdxType="ComparisonResultHeroUserLocation" />
    </ComparisonResultsPageHero>
    <ComparisonResultGrid columnConfiguration={resultGridConfig.columnConfiguration} mdxType="ComparisonResultGrid">
  <SplashFinancialLogo className="w-full" imagekey="splash-financial" mdxType="SplashFinancialLogo" />
  <EarnestLogo className="w-full" imagekey="earnest" mdxType="EarnestLogo" />
    </ComparisonResultGrid>
    <ComparisonResultColumnContent blogContentCategory="loans" mdxType="ComparisonResultColumnContent">
      <ComparisonResultColumnContentBackgroundContainer mdxType="ComparisonResultColumnContentBackgroundContainer">
        <h2>{`How We Ranked Student Loan Providers`}</h2>
        <p>{`When it’s time to look at companies providing student loan relief to college students, there are many qualifications we used to determine which providers are the best of the best.`}</p>
        <h3>{`Region`}</h3>
        <p>{`One of the first qualifiers we looked at was whether these providers serviced students exclusively and if any of these companies were committed to helping students with the cost of in-state tuition. The majority of providers on this list are focused on helping residents become successful college students at state schools.`}</p>
        <h3>{`Type of Loan`}</h3>
        <p>{`We also looked at what kind of loans the provider worked with. To pay for college, schools accept private or federal loans to cover the cost of tuition as well as sometimes housing and other school expenses, such as textbooks and graduate requirements. While many of these companies work with both private and federal loans, several others serve either one or the other. It’s important to know the kind of loan you need and can qualify for when searching for loan providers.`}</p>
        <h3>{`Consolidation or Refinancing?`}</h3>
        <p>{`Along with the type of loans these companies provide, we examined whether these companies consolidate or refinance loans. Many companies offer both services. Loan consolidation is perhaps more useful for students who have loans from multiple lenders, both federal and private, and are interested in bringing all loans together to make one monthly payment. Refinancing loans are ideal for students who want to lower their monthly payments or their interest rates to be able to pay the loan off within their financial budget.`}</p>
        <h3>{`Eligibility Requirements`}</h3>
        <p>{`We also looked at the eligibility requirements for these loans. Some providers have strict requirements, such as the enrollment status of the student and the type of program they are enrolled in.`}</p>
        <h3>{`Provider History`}</h3>
        <p>{`Finally, we took into consideration the history of these providers, particularly the non-profit institutions that have good reputations for helping college students.`}</p>
      </ComparisonResultColumnContentBackgroundContainer>
      <ComparisonResultGettingStartedBlock mdxType="ComparisonResultGettingStartedBlock" />
      <ComparisonPageRecommendations requestingProductCategory="student refinancing loans" mdxType="ComparisonPageRecommendations" />
      <ComparisonResultPageLearnMoreContainer mdxType="ComparisonResultPageLearnMoreContainer">
        <h3>{`Learn More`}</h3>
        <p>{`There are many companies that are devoted to helping current and graduated students take back control over their financial health. When it’s time to compare loans, turn to `}<a parentName="p" {...{
            "href": "/"
          }}>{`The Comparison Company`}</a>{` to find the student loan program right for you.`}</p>
      </ComparisonResultPageLearnMoreContainer>
    </ComparisonResultColumnContent>


    <p>{`;`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      